import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  OnChanges
} from '@angular/core';
import {IDropdownSettings} from 'ng-multiselect-dropdown';
import {licExternalReviewStatuses} from '../../project/project.constants';

interface DropdownItem {
  id: string | number;
  text: string | number;
  isDisabled?: boolean;
}

@Component({
  selector: 'fl-event-notification-action-multiselect',
  templateUrl: './event-notification-action-multiselect.component.html',
  styleUrls: ['./event-notification-action-multiselect.component.scss']
})
export class EventNotificationActionMultiselectComponent
  implements OnInit, OnChanges {
  @Output()
  change: EventEmitter<string[]> = new EventEmitter<string[]>();

  @Input()
  eventActions: string[] = [];

  eventActionsOptions: DropdownItem[] = [];

  @Input()
  selectedEventActions: string[] = [];

  localSelectedEventActions: DropdownItem[] = [];


  @Input() agency!: string;

  showDropdown = true;


  //#region Settings
  dropdownSettings = <IDropdownSettings>{
    singleSelection: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true,
    enableCheckAll: true,
  };
  //#endregion


  constructor() {
  }

  buildEventActionsOptions() {
    this.eventActionsOptions = this.eventActions.map(x => ({
      id: x,
      text: this.parseDisplayNameFromActionName(x)
    }));
  }
  buildEventActionSelected() {
    this.localSelectedEventActions = this.eventActionsOptions.filter(option =>
      this.selectedEventActions.includes(option.id.toString())
    );
  }

  ngOnInit() {
    this.buildEventActionsOptions();
    this.buildEventActionSelected();

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['eventActions']) {
      this.buildEventActionsOptions();
    }
    if (changes['eventActionsOptions']) {
      this.buildEventActionSelected();
    }
  }

  parseDisplayNameFromActionName(name: string): string {
    if (this.agency && this.agency === 'localITEPCommitteeContact') {
      if (name === 'Objection') {
        return licExternalReviewStatuses.nonRecommend.displayName;
      }
      if (name === 'No Objection') {
        return licExternalReviewStatuses.recommend.displayName;
      }
    }
    return name;
  }

  onManualSelect(item: DropdownItem) {
    const matched = this.eventActionsOptions.find(opt => opt.id === item.id);
    if (matched && !this.localSelectedEventActions.includes(matched)) {
      this.localSelectedEventActions.push(matched);
    }
    this.change.emit(this.localSelectedEventActions.map(x => x.id.toString()));
  }

  onManualDeSelect(item: DropdownItem) {
    this.localSelectedEventActions = this.localSelectedEventActions.filter(x => x.id !== item.id);
    this.change.emit(this.localSelectedEventActions.map(x => x.id.toString()));
  }

  onManualSelectAll(items: DropdownItem[]) {
    const selectedIds = items.map(x => x.id.toString());
    this.localSelectedEventActions = this.eventActionsOptions.filter(option =>
      selectedIds.includes(option.id.toString())
    );
    this.change.emit(this.localSelectedEventActions.map(x => x.id.toString()));
  }

  onManualDeSelectAll() {
    this.selectedEventActions = [];
    this.change.emit([]);
  }

}
